/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoices_TabInputs */

const en_invoices_tab = /** @type {(inputs: Invoices_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoices`)
};

const fr_invoices_tab = /** @type {(inputs: Invoices_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Factures`)
};

const de_invoices_tab = /** @type {(inputs: Invoices_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungen`)
};

const it_invoices_tab = /** @type {(inputs: Invoices_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatture`)
};

const ru_invoices_tab = /** @type {(inputs: Invoices_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Счета-фактуры`)
};

const es_invoices_tab = /** @type {(inputs: Invoices_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturas`)
};

const zh_cn2_invoices_tab = /** @type {(inputs: Invoices_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发票`)
};

const ja_invoices_tab = /** @type {(inputs: Invoices_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`請求書`)
};

const hi_invoices_tab = /** @type {(inputs: Invoices_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चालान`)
};

const pt_pt2_invoices_tab = /** @type {(inputs: Invoices_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faturas`)
};

/**
* | output |
* | --- |
* | "Invoices" |
*
* @param {Invoices_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const invoices_tab = /** @type {((inputs?: Invoices_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoices_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_invoices_tab(inputs)
	if (locale === "de") return de_invoices_tab(inputs)
	if (locale === "it") return it_invoices_tab(inputs)
	if (locale === "ru") return ru_invoices_tab(inputs)
	if (locale === "es") return es_invoices_tab(inputs)
	if (locale === "zh-CN") return zh_cn2_invoices_tab(inputs)
	if (locale === "ja") return ja_invoices_tab(inputs)
	if (locale === "hi") return hi_invoices_tab(inputs)
	if (locale === "pt-PT") return pt_pt2_invoices_tab(inputs)
	return en_invoices_tab(inputs)
});